// Source names are literal identifiers. Dots inside a name never separate components.
export function sourceReferenceKey(reference) {
  if (!reference) return '';
  if (typeof reference !== 'object' || ['catalog', 'schema', 'name'].some(field => typeof reference[field] !== 'string' || !reference[field])) {
    throw new Error('Source references require literal catalog, schema and name components.');
  }
  return JSON.stringify([reference.catalog, reference.schema, reference.name]);
}

export function sourceReferenceLabel(reference) {
  if (!reference) return '';
  return [reference.catalog, reference.schema, reference.name].map(part => JSON.stringify(part)).join('.');
}

export function externalConnectionLocation(connection) {
  if (!connection) return '';
  const config = connection.config || {};
  return JSON.stringify([
    connection.operation_id, connection.dialect,
    config.host, String(config.port ?? ''), config.database, config.account,
    config.project, config.dataset, config.catalog, config.schema,
    config.server_hostname, config.http_path,
  ]);
}

export function externalSchemaSignature(columns) {
  return JSON.stringify(columns.map(column => [
    column.remote, column.native_type, column.proposed_type, column.mappable,
  ]).sort((left, right) => left[0].localeCompare(right[0])));
}
